import React, { useReducer, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'

import CampaignForm from './CampaignForm'
import VariationIndicator from '../VariationIndicator'
import { isCampaignRunning } from '../../../../api/models'
import { useCampaignSetup } from '../Context/CampaignSetupContext'

function updateReducer(state, action) {
  return {
    ...state,
    totalHeadlines: action.payload.headline?.filter(Boolean).length ?? 0,
    totalBodies: action.payload.body?.filter(Boolean).length ?? 0,
    totalMediaFiles: action.payload.media?.filter(Boolean).length ?? 0,
  }
}

export function CampaignEditor({
  eventId,
  eventDate,
  eventInfo,
  campaign,
  goal,
  onCancel,
  showValidationErrors = false,
  ...rest
}) {
  const { setup } = useCampaignSetup()
  const creative = useMemo(
    () => setup.creatives.find((x) => x.tc === campaign.tc) || { tc: campaign.tc },
    [setup.creatives, campaign.tc]
  )
  const initialCounts = {
    totalHeadlines: creative.headline?.filter(Boolean).length ?? 0,
    totalBodies: creative.body?.filter(Boolean).length ?? 0,
    totalMediaFiles: creative.media?.filter(Boolean).length ?? 0,
  }
  const [creativeCounts, dispatchCreativeCountsAction] = useReducer(updateReducer, initialCounts)
  useEffect(() => {
    // update counts
    dispatchCreativeCountsAction({ payload: creative })
  }, [creative, dispatchCreativeCountsAction])

  return (
    <>
      {!isCampaignRunning(campaign) && <VariationIndicator {...creativeCounts} />}
      <CampaignForm
        eventId={eventId}
        eventDate={eventDate}
        eventInfo={eventInfo}
        campaign={campaign}
        goal={goal}
        onCancel={onCancel}
        showValidationErrors={showValidationErrors}
        {...rest}
      />
    </>
  )
}

CampaignEditor.propTypes = {
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  eventDate: PropTypes.string.isRequired,
  eventInfo: PropTypes.object,
  campaign: PropTypes.object.isRequired,
  goal: PropTypes.string,
  onCancel: PropTypes.func,
  showValidationErrors: PropTypes.bool,
}
